import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from '../../ThemeContext';

import {
  Card,
  CardInner,
  Content,
  ContentInner,
  Title,
  Button,
} from './DataSource.style';

const DataSourceEmpty = ({ handleAction = () => {} }) => {
  const theme = useTheme();
  const intl = useIntl();

  const renderContent = () => {
    return (
      <Content>
        <ContentInner>
          <Title theme={theme.dataSource.title}>
            {intl.formatMessage({
              id: `DATA_SOURCES_EMPTY.ADD_ANOTHER_DATA_SOURCE`,
            })}
          </Title>
          <Button
            theme={theme.button.default}
            onClick={() => handleAction({ type: 'CREATE' })}
          >
            {intl.formatMessage({
              id: `DATA_SOURCES_EMPTY.ADD`,
            })}
          </Button>
        </ContentInner>
      </Content>
    );
  };

  return (
    <Card theme={theme.content.card.default}>
      <CardInner>{renderContent()}</CardInner>
    </Card>
  );
};

export default DataSourceEmpty;
